import { Redirect, Route } from "react-router-dom";
import React from "react";
import PropTypes from "prop-types";
import AppConfig from "../config/AppConfig";
import { getAuthInfo, isLoggedIn } from "store/slices/auth";
import { useSelector } from "react-redux";

const AuthRoute = ({ component: Component, ...rest }) => {
  const loggedIn = useSelector(isLoggedIn) || false;
  const user = useSelector(getAuthInfo) || {};

  return (
    <Route
      {...rest}
      render={(props) => {
        return !loggedIn ? (
          <Component path={rest.path} {...props} />
        ) : user.role === AppConfig.USER_ROLES.ADMIN ? (
          <Redirect
            to={{
              pathname: "/admin/dashboard",
              state: { from: props.location },
            }}
            push
          />
        ) : (
          <Redirect
            to={{
              pathname: "/dashboard",
              state: { from: props.location },
            }}
            push
          />
        );
      }}
    />
  );
};

AuthRoute.propTypes = {
  component: PropTypes.any,
  path: PropTypes.any,
  location: PropTypes.object,
};

export default AuthRoute;
